import { render, staticRenderFns } from "./DemoNotice.vue?vue&type=template&id=f732c088&scoped=true&"
import script from "./DemoNotice.vue?vue&type=script&lang=js&"
export * from "./DemoNotice.vue?vue&type=script&lang=js&"
import style0 from "./DemoNotice.vue?vue&type=style&index=0&id=f732c088&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f732c088",
  null
  
)

export default component.exports